import { useEffect, useState } from "react"

export default function useIsFullscreenEnabled() {
  const [isFullscreenEnabled, setIsFullscreenEnabled] = useState(false)
  useEffect(() => {
    setIsFullscreenEnabled(document.fullscreenEnabled)
  }, [])
  return true
}
